export default __webpack_public_path__ + "static/media/swipe-right-color.c2e40b26.svg";